









import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import VuePlotly from '@statnett/vue-plotly';

@Component({
    components: {
        VuePlotly
    }
})
export default class CommoditySunburst extends Vue {
    @Prop({ required: true }) commodity_items!: { [main: string]: string[] };
    @Prop({ default: "" }) selectedCommodity!: string;

    /*root: string = ''*/

    //@Watch('selectedCommodity')
    //updateSunburst(newVal: any, oldVal: any) {
    //    this.root = "";
    //}

    get sunburstData() {
        var labels = this.sunburstHierarchy.map(c => c.label);
        var ids = this.sunburstHierarchy.map(c => c.id);
        var parents = this.sunburstHierarchy.map(c => c.parent || "");

        // Assign commodity colors
        var colors = this.sunburstHierarchy.map((item) => {
            // Use parent if subcommodity, or id if it's a top-level commodity
            var baseId = item.parent || item.id;
            return this.commodityColors[baseId] || "#000000"; // default black
        });

        //var focusId = this.root.toLowerCase() || "";

        return [{
            type: "sunburst",
            /*root: { id: this.root },*/
            labels,
            ids,
            parents,
            outsidetextfont: { size: 16, color: "#333" },
            leaf: { opacity: 0.7 },
            marker: {
                line: { width: 0.2 },
                colors
            },
            branchvalues: "total",
        }];
    }

    get sunburstLayout() {
        return {
            title: {
                text: 'Commodity Breakdown',
                font: {
                    size: 20,
                    color: '#333',
                    family: 'Roboto',
                },
                x: 0.5, // Center the title
                xanchor: 'center'
            },
            margin: { l: 0, r: 0, b: 0, t: 50 },
            hovermode: 'closest',
        };
    }

    handleClick(event: any) {
        var clickedLabel = event?.points?.[0]?.label; // use label here as it matches commdity values in v-select
        var clickedItem = this.sunburstHierarchy.find(c => c.label === clickedLabel);

        // Only emit if top-level (no parent)
        if (clickedItem && !clickedItem.parent) {
            this.$emit('select', clickedItem.label);
        }
    }

    get sunburstHierarchy() {
        var hierarchy: { id: string; label: string; parent: string | "" }[] = [];

        Object.keys(this.commodity_items).forEach(mainKey => {
            var mainId = mainKey.toLowerCase();
            var mainLabel = this.capitalize(mainKey);

            // Top-level commodity node
            hierarchy.push({
                id: mainId,
                label: mainLabel,
                parent: ""
            });

            var subcommodities = this.commodity_items[mainKey];
            if (!Array.isArray(subcommodities)) return;

            subcommodities.forEach(sub => {
                var subRaw = sub.toLowerCase();

                // Handle case where sub == parent
                var isSelfRef = subRaw === mainId;

                // Unique ID to avoid duplicates for shared sub names
                var subId = `${mainId}-${subRaw}`;

                // Add "\u200B" (zero-width space) only if sub == parent to distinguish label
                var subLabel = isSelfRef
                    ? `${this.capitalizeWords(sub)} \u200B`
                    : this.capitalizeWords(sub);

                hierarchy.push({
                    id: subId,
                    label: subLabel,
                    parent: mainId
                });
            });
        });

        return hierarchy;
    }

    // Capitalize first letter
    capitalize(word: string): string {
        return word.charAt(0).toUpperCase() + word.slice(1);
    }

    // Capitalize compound words (e.g. "fruit_juice" => "Fruit Juice")
    capitalizeWords(text: string): string {
        return text
            .split("_")
            .map(w => this.capitalize(w))
            .join(" ");
    }

    get commodityColors(): Record<string, string> {
        return {
            mandarins: "#FFA726",
            apples: "#66BB6A",
            liquor: "#8D6E63",
            tomatoes: "#EF5350",
            melons: "#FFC0CB",
            kiwifruit: "#9CCC65",
            grapes: "#AB47BC",
            bananas: "#FDD835",
            oranges: "#FF9800",
        };
    }
}
